/**
 * MCP hero copy for /api — what it is, who uses it, and example prompts.
 */

export const MCP_EXPLAINER =
  "Model Context Protocol: a standard way for AI agents to call Humblytics tools live (traffic, funnels, split tests, heatmaps, and more)."

/** One value line and one subline, shared by the hub card and the /api hero. */
export const MCP_HEADLINE = "Ask Claude, Cursor or Codex about your traffic, funnels and tests."
export const MCP_SUBLINE = "Reads traffic, funnels, heatmaps and test results. It changes nothing without you."

export const MCP_TOOL_CATEGORIES = [
  "Traffic",
  "Funnels",
  "A/B tests",
  "Heatmaps",
] as const

export type McpExamplePrompt = {
  id: string
  prompt: string
}

export const MCP_EXAMPLE_PROMPTS: McpExamplePrompt[] = [
  { id: "top-source", prompt: "What's my top traffic source this week?" },
  { id: "funnel-drop", prompt: "Where's the biggest drop in my checkout funnel?" },
  { id: "ab-ready", prompt: "Which A/B test is ready to call?" },
  { id: "cro-brief", prompt: "Write me a weekly brief on traffic, funnel leaks and test ideas." },
]
